import { Building, Building2, Calendar, Clock, Globe, Mail, MapPin, Phone, User } from 'lucide-react';
import { formatDateTime } from 'utils/dateFormatter';
import { getStatusColor, getVerificationStatus } from '../utils';

const OverviewTab = ({ seller, staffs }) => {
  return (
    <>
      {/* Personal Information */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <User className='mr-2' size={20} />
          Personal Information
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>

          <div>
            <label className='text-xs text-muted-foreground'>Name</label>
            <div className='flex items-center gap-2 mt-1'>
              <User size={16} className='text-muted-foreground' />
              <p className='text-sm font-medium'>
                {seller?.firstName} {seller?.lastName}
              </p>
            </div>
          </div>

            {/* Restaurant name */}
           {seller?.willSellFood && (
  <div>
    <label className='text-xs text-muted-foreground'>Restaurant Name</label>
    <div className='flex items-center gap-2 mt-1'>
      <Building size={16} className='text-muted-foreground' />
      <p className='text-sm font-medium'>
        {seller?.restaurantName}
      </p>
    </div>
  </div>
)}

          <div>
            <label className='text-xs text-muted-foreground'>Phone Number</label>
            <div className='flex items-center gap-2 mt-1'>
              <Phone size={16} className='text-muted-foreground' />
              <p className='text-sm font-medium'>
                {seller?.countryCode} {seller?.phoneNumber}
              </p>
              {getVerificationStatus(seller?.phoneVerified)}
            </div>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Email</label>
            <div className='flex items-center gap-2 mt-1'>
              <Mail size={16} className='text-muted-foreground' />
              <p className='text-sm font-medium'>{seller?.email || 'N/A'}</p>
              {/* {seller?.email && getVerificationStatus(seller?.emailVerified)} */}
            </div>
          </div>
          {/* <div>
            <label className='text-xs text-muted-foreground'>Gender</label>
            <p className='text-sm font-medium mt-1 capitalize'>{seller?.gender || 'N/A'}</p>
          </div> */}
          {/* <div>
            <label className='text-xs text-muted-foreground'>Date of Birth</label>
            <p className='text-sm font-medium mt-1'>
              {seller?.dateOfBirth ? new Date(seller.dateOfBirth).toLocaleDateString() : 'N/A'}
            </p>
          </div> */}
          <div>
            <label className='text-xs text-muted-foreground'>Joined</label>
            <div className='flex items-center mt-1'>
              <Calendar size={16} className='mr-2 text-muted-foreground' />
              <p className='text-sm font-medium'>{formatDateTime(seller?.createdAt)}</p>
            </div>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Last Active</label>
            <div className='flex items-center mt-1'>
              <Clock size={16} className='mr-2 text-muted-foreground' />
              <p className='text-sm font-medium'>{formatDateTime(seller?.lastActiveAt)}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Categories */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <Building2 className='mr-2' size={20} />
          Service Categories
        </h2>
        <div className='space-y-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Main Category</label>
            <p className='text-sm font-medium mt-1'>{seller?.categories?.name?.english || 'N/A'}</p>
          </div>
          <div>
            {seller?.sub_categories?.length > 0 && (
        <div>
    <label className='text-xs text-muted-foreground'>Sub Categories</label>
    <div className='flex flex-wrap gap-2 mt-2'>
      {seller.sub_categories.map((subCat) => (
        <span
          key={subCat._id}
          className='px-3 py-1 text-xs font-medium rounded-full bg-primary/10 text-primary'
        >
          {subCat.name?.english}
        </span>
      ))}
    </div>
  </div>
)}
          </div>
        </div>
      </div>

          {/* Food Related Section */}
         {seller?.willSellFood && (
  <div className='bg-card border border-border rounded-lg p-6'>
    <h2 className='text-lg font-semibold mb-4 flex items-center'>
      <Clock className='mr-2' size={20} />
      Operating Hours
    </h2>

    <div className='space-y-4'>
      <div>
        <label className='text-xs text-muted-foreground'>Opening Time</label>
        <p className='text-sm font-medium mt-1'>
          {seller?.foodOperatingHours?.openingHours || 'N/A'}
        </p>
      </div>

      <div>
        <label className='text-xs text-muted-foreground'>Closing Time</label>
        <p className='text-sm font-medium mt-1'>
          {seller?.foodOperatingHours?.closingHours || 'N/A'}
        </p>
      </div>
    </div>
  </div>
)}

      {/* Address */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <MapPin className='mr-2' size={20} />
          Address
        </h2>
        <div className='space-y-2'>
          <p className='text-sm'>{seller?.address?.addressLine1 || 'N/A'}</p>
          {seller?.address?.addressLine2 && <p className='text-sm'>{seller.address.addressLine2}</p>}
          <p className='text-sm text-muted-foreground'>
            {[
              seller?.address?.landmark,
              seller?.address?.city,
              seller?.address?.state,
              seller?.address?.pincode,
              seller?.address?.country,
            ]
              .filter(Boolean)
              .join(', ')}
          </p>
          {seller?.address?.location?.coordinates && (
            <p className='text-xs text-muted-foreground'>
              Coordinates: {seller.address.location.coordinates[1]}, {seller.address.location.coordinates[0]}
            </p>
          )}
        </div>
      </div>

{/* Staff Members */}
{staffs?.length > 0 && (
  <div className='bg-card border border-border rounded-lg p-6'>
    <h2 className='text-lg font-semibold mb-4 flex items-center'>
      <User className='mr-2' size={20} />
      Staff Members ({staffs.length})
    </h2>

    <div className='space-y-3'>
      {staffs.map((staff) => (
        <div
          key={staff._id}
          className='flex items-center gap-4 border border-border rounded-lg p-3'
        >
          <div className='h-12 w-12 rounded-full overflow-hidden border bg-muted flex items-center justify-center'>
            {staff?.profilePhoto ? (
              <img
                src={staff.profilePhoto}
                alt={`${staff.firstName} ${staff.lastName}`}
                className='h-full w-full object-cover'
              />
            ) : (
              <User size={20} className='text-muted-foreground' />
            )}
          </div>

          <div className='flex-1'>
            <p className='font-medium'>
              {staff.firstName} {staff.lastName}
            </p>

            <p className='text-sm text-muted-foreground'>
              {staff.email || 'N/A'}
            </p>

            <p className='text-sm text-muted-foreground'>
              {staff.phoneNumber || 'N/A'}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
)}

      {/* Availability */}
      {/* <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <Globe className='mr-2' size={20} />
          Availability
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Online Status</label>
            <p className='text-sm font-medium mt-1'>
              {seller?.availability?.isOnline ? (
                <span className='text-green-600'>Online</span>
              ) : (
                <span className='text-gray-600'>Offline</span>
              )}
            </p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Order Status</label>
            <p className='text-sm font-medium mt-1'>
              {seller?.availability?.isPausedOrder ? (
                <span className='text-yellow-600'>Paused</span>
              ) : (
                <span className='text-green-600'>Active</span>
              )}
            </p>
          </div>
          {seller?.availability?.autoOfflineAt && (
            <div>
              <label className='text-xs text-muted-foreground'>Auto Offline At</label>
              <p className='text-sm font-medium mt-1'>{formatDateTime(seller.availability.autoOfflineAt)}</p>
            </div>
          )}
        </div>
      </div> */}
    </>
  );
};

export default OverviewTab;
